import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { Helmet } from 'react-helmet-async';
import { BackLink } from '@/components/presentation/Back';
import * as pathname from '@/consts/path';
import styles from './style/Folder.NotFound.module.css';

export default function FolderNotFound() {
  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <Helmet title="Folder not found" />
        <div className={styles.icon}><ErrorIcon /></div>
        <div className={styles.copy}>Folder does not exist</div>
        <div className={styles.back}>
          <BackLink to={`${pathname.Home}`} />
        </div>
      </div>
    </div>
  );
}

export { FolderNotFound };